import React, { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useStyles from "./style";
import {Grid, Typography} from "@mui/material";
import { DataGrid  } from "@mui/x-data-grid";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import moment from 'moment-timezone';
import { CUSTOM_CONSTANTS } from "Constants";

//Services
import DriverApi from "Services/Driver"

const Driverearningslogs = () => {
  const { id:userId } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [totalamount, setTotalamount] = useState(0);
  const timezone = useSelector((state) => state.timezone.timezone);
  
  // Get userWallet list api
  const getdriverearningslogs = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status===200) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    DriverApi.getdriverEarning({ page, limit: pageSize , userId:userId}).then(onSuccess, onFailure);
  }, [page, pageSize]);

  useEffect(() => {
    getdriverearningslogs();
  }, [getdriverearningslogs]);

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const formatDate = (inputDate) => {
    if (!inputDate) return "--";
    const parsed = moment(inputDate);
    if (!parsed.isValid()) return "--";
    const safeTimezone = timezone || "UTC";
    return parsed.tz(safeTimezone).format("YYYY-MM-DD hh:mm A");
  };

  const dataRows = _.map(row || [], (data, index) => ({
    id: data?._id || data?.id || data?.bookingId || `${page}-${index}`,
    sno: calculateSno(page, pageSize, index),
    username: data?.userdetails?.user_name,
    email: data?.userdetails?.email,
    booking_id: data?.bookingId,
    earnings:data?.earnings,
    earningStatus:data?.earningStatus || "",
    createdAt: formatDate(data?.createdAt),
    row: data,
  }));
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      width: 90,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "username",
      headerName: "Name",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
          <Typography variant="body2"  
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontWeight:"bold",
            color: "#9c27b0", // Optional: Color to indicate it's clickable
          }}>{params?.row?.username}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.email}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "booking_id",
      headerName: "Booking id",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.booking_id}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "earnings",
      headerName: "Earning",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.earnings+" "+CUSTOM_CONSTANTS.BASE_CURRENCY}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "earningStatus",
      headerName: "Earning Status",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.earningStatus}</Typography>
            </div>
          </>
        );
      },
    },    
    {
      field: "createdAt",
      headerName: "Date",
      width: 200,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.createdAt}</Typography>
            </div>
          </>
        );
      },
    }
  ];

  return (
    <>
{/*Earning details */}
<Grid container className={classes.walletdetails}>
  <Grid item xs={12}>
  <div style={{ overflowX: "auto" }}>
  <div style={{ minWidth: "1100px" }}>
    <section className={classes.dataGridTable}>
      <DataGrid
        getRowId={(gridRow, index) => gridRow?.id || gridRow?.row?._id || gridRow?.booking_id || `earning-log-${index}`}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={70}
        style={{ padding: "10px", borderRadius: "0px" }}
        paginationMode="server"
        rowCount={totalPages}
      />
    </section>
   </div> 
   </div>
  </Grid>
</Grid>


    </>
  );
};

export default Driverearningslogs;
